<div class="swiper-categories-slide" (click)="onCategoryClick()">
    <img [src]="category.icon?.url" [alt]="category.displayName" />
    <p [innerHTML]="category.formattedDisplayName"></p>
</div>